import React, { useState } from 'react';
import { Database, CheckCircle2 } from 'lucide-react';
import { useSecurity } from '../security/SecurityContext';
import { API, authFetch } from '../lib/api';

// ─── DB Control (RC26masterDB) ──────────────────────────────────────────────────
export default function DBControl() {
  const { mssqlConnected } = useSecurity();
  const [verifying, setVerifying] = useState(false);
  const [res, setRes]             = useState(null);

  const verify = async () => {
    setVerifying(true);
    setRes(null);
    try {
      const response = await authFetch(`${API}/db/verify-connection`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ clientToken: 'SIMULATED_HANDSHAKE_PULSE' })
      });
      setRes(await response.json());
    } catch { setRes({ success: false, error: 'CONNECTION_REJECTED' }); }
    finally { setVerifying(false); }
  };

  return (
    <div className="card" style={{ maxWidth: 800, margin: '0 auto', padding: 48, textAlign: 'center' }}>
      <div style={{ width: 72, height: 72, background: res?.success ? '#f0fdf4' : res?.error ? '#fef2f2' : '#eff6ff', borderRadius: 16, display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 24px', border: `1px solid ${res?.success ? '#bbf7d0' : res?.error ? '#fecaca' : '#bfdbfe'}` }}>
        {verifying ? <div className="spinner" style={{ width: 32, height: 32 }} /> : <Database size={36} color={res?.success ? '#16a34a' : res?.error ? '#dc2626' : '#3b82f6'} />}
      </div>

      <h2 style={{ fontSize: 26, fontWeight: 900, color: '#0f172a', marginBottom: 12 }}>RC26masterDB Master Node</h2>
      <p style={{ color: '#64748b', marginBottom: 32, lineHeight: 1.7, maxWidth: 480, margin: '0 auto 32px' }}>
        IP-locked database node for MSN-CLIQ RETAIL ERP. Connection integrity validated via transient DNA hashes and AES-256-GCM handshake.
      </p>

      <div className="db-terminal" style={{ maxWidth: 560, margin: '0 auto 32px', textAlign: 'left' }}>
        {res?.success && <div style={{ position: 'absolute', top: 12, right: 16 }}><CheckCircle2 size={14} color="#10b981" /></div>}
        <div className="comment">// RC26_DB_SEC_LAYER_v4</div>
        <div style={{ marginTop: 8, display: 'flex', flexDirection: 'column', gap: 4 }}>
          <div><span className="key">TARGET: </span><span className="val">{process.env.REACT_APP_MSSQL_SERVER || '120.138.9.33'}:58842</span></div>
          <div><span className="key">USER: </span><span className="val">sa_erp_secured</span></div>
          <div><span className="key">MSSQL: </span><span className={mssqlConnected ? 'success' : ''} style={!mssqlConnected ? { color: '#f59e0b' } : {}}>{mssqlConnected ? 'CONNECTED' : 'FILE-ONLY MODE'}</span></div>
          <div><span className="key">STATUS: </span><span className={res?.success ? 'success' : res?.error ? 'error-t' : ''}>
            {verifying ? 'PULSING...' : res?.success ? 'IDENTIFIED & CONNECTED' : res?.error ? 'HANDSHAKE_ERROR' : 'IDLE'}
          </span></div>
          {res?.success && (
            <div style={{ marginTop: 12, paddingTop: 12, borderTop: '1px solid #1e293b' }}>
              <div className="success" style={{ fontSize: 9, fontWeight: 700, textTransform: 'uppercase', marginBottom: 6 }}>Validated Timestamp Handshake:</div>
              <div style={{ background: '#0f172a', padding: '6px 10px', borderRadius: 4, fontSize: 9, color: '#93c5fd', wordBreak: 'break-all', border: '1px solid rgba(59,130,246,0.2)' }}>
                {res.handshakeId || 'TXN_HANDSHAKE_9921_FVP'}
              </div>
              <div style={{ marginTop: 6, fontSize: 9, color: '#475569' }}>Encryption: AES-256-GCM / SHA-512_DNA_BOUND</div>
            </div>
          )}
        </div>
      </div>

      <button className="btn btn-primary" onClick={verify} disabled={verifying} style={{ fontSize: 12, padding: '13px 40px' }} data-testid="db-verify-btn">
        {verifying ? 'Connecting via DNA Pulse...' : 'Verify Connection Integrity'}
      </button>
    </div>
  );
}
